export default Object.freeze({
  list: [],
  info: {},
});
